import $ from 'jquery';
import NewsService from '../service/NewsService';
import HistoryManager from '../util/HistoryManager';

let page = 1;
let section = $('.news__tabs .content-tabs-nav__item--active').data('section');

const getItems = (replaceFirst = false) => {
    const parameters = { page };
    if (section) {
        parameters.section = section;
    }

    NewsService.getItems(parameters)
        .then((response) => {
            if (response.nextpage) {
                $('.news-more').removeClass('button--hidden');
            } else {
                $('.news-more').addClass('button--hidden');
            }
            NewsService.renderItems(response.items, page > 1);

            if (replaceFirst) {
                NewsService.renderMainItem(response.first);
            }
        });
};

$('.news__tabs .content-tabs-nav__item').click(function () {
    const newSection = $(this).data('section');

    if (!section && !newSection || section === newSection) {
        return;
    }
    section = newSection;
    page = 1;

    if (section) {
        HistoryManager.push(`/news?section=${section}`, { section });
    } else {
        HistoryManager.push('/news');
    }

    getItems(true);
});

if ($('.news__tabs').length) {
    HistoryManager.replace(`${window.location.pathname}${window.location.search}`, section ? { section } : {});
    HistoryManager.onState((event) => {
        section = event.state.section;
        page = 1;

        $('.content-tabs-nav__item').removeClass('content-tabs-nav__item--active');
        if (section) {
            $(`.content-tabs-nav__item[data-section=${section}]`).addClass('content-tabs-nav__item--active');
        } else {
            $(`.content-tabs-nav__item`).first().addClass('content-tabs-nav__item--active');
        }

        getItems(true);
    });
}

$('.news-more').click(function () {
    page += 1;
    getItems();
});
